export const kiirasTipusok = new Map<number, string>([
    [0, "Nincs"],
    [1, "Statikus"],
    [2, "Parking lot szabad helyek"]
]);
